
import { useState } from 'react';
import type { MontonioPaymentMethod } from './types';
import { isValidMontonioPaymentMethod, isValidBankId } from './validators';

interface PaymentProcessorProps {
  onSubmit: (paymentInfo?: { 
    paymentMethod: MontonioPaymentMethod; 
    selectedBank: string | null;
    returnPath?: string;
  }) => void;
}

export function usePaymentProcessor({ onSubmit }: PaymentProcessorProps) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);

  const handlePaymentSubmit = (
    selectedBank: string,
    paymentMethod: MontonioPaymentMethod = "paymentInitiation",
    returnPath?: string
  ) => {
    try {
      // Reset any previous errors
      setValidationError(null);
      
      // Validate the payment method
      if (!isValidMontonioPaymentMethod(paymentMethod)) {
        setValidationError(`Kehtetu maksemeetod: ${paymentMethod}`);
        return;
      }
      
      // Validate the bank ID if provided
      if (selectedBank && !isValidBankId(selectedBank)) {
        setValidationError("Kehtetu panga valik");
        return;
      }
      
      setIsProcessing(true);
      
      console.log("💥 usePaymentProcessor: Makse töötlemine pangaga:", selectedBank);
      console.log("💥 usePaymentProcessor: Kasutan maksemeetodit:", paymentMethod);
      if (returnPath) {
        console.log("💥 usePaymentProcessor: Tagastamistee:", returnPath);
      }
      
      // Call the parent onSubmit with the validated information
      onSubmit({
        paymentMethod,
        selectedBank,
        returnPath
      });
      
    } catch (err) {
      console.error("💥 usePaymentProcessor: Viga makse töötlemisel:", err);
      setIsProcessing(false);
      throw err;
    }
  };

  return {
    isProcessing,
    validationError,
    handlePaymentSubmit
  };
}
